<template>
    <div class="login-page">
      <h1 class="login-title">Forget Password</h1>
  
      <div class="login-form">
        <div class="login-form-inner">
          <div class="form-group">
            <label>Username</label>
            <input ref="username" type="text" class="form-control" placeholder="Username">
          </div>
          <div class="action-buttons">
            <button @click="forgetPassword" class="btn btn-primary btn-black">Get Password</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex';
  
  export default {
    name: 'ForgetPassword',
    methods: {
      async forgetPassword(){
        alert('If your username is correct, admin will send an email with your password.');
        this.$router.push('/');
      },
    },
    computed: mapState({
     apiUrl: state => state.apiUrl,
   }),
  }
  </script>
  
  
  <style lang="scss">
  #form-error{
    text-align: center;
  }
  .login-title{
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
  }
  
  .login-logo{
    width: 200px;
  }
  
  #form-error{
    display: block;
    margin-top: 20px;
    margin-bottom: 50px;
  }
  
  .login-form{
    display: flex;
    justify-content: center;
  
    .login-form-inner{
      max-width: 500px;
      width: 100%;
    }
  
    .btn-black{
      margin-top: 15px;
      margin-right: 20px;
    }
  }
  </style>
  